import React from 'react'
export default function ResponsiveImage ({ image, ...props }) {
  return (
    <picture>
      {image?.sizes?.['1536x1536'] && (
        <source
          media='(min-width: 1152px) and (max-height: 1536px)'
          srcSet={image?.sizes?.['1536x1536']}
        />
      )}
      {image?.sizes?.['2048x2048'] && (
        <source
          media='(min-width: 1536px) and (max-height: 2048px)'
          srcSet={image?.sizes?.['2048x2048']}
        />
      )}
      {image?.sizes?.large && (
        <source
          media='(min-width: 768px) and (max-height: 1024px)'
          srcSet={image?.sizes?.large}
        />
      )}
      {image?.sizes?.medium && (
        <source
          media='(min-width: 225px) and (max-height: 300px)'
          srcSet={image?.sizes?.medium}
        />
      )}
      {image?.sizes?.thumbnail && (
        <source
          media='(min-width: 113px) and (max-height: 150px)'
          srcSet={image?.sizes?.thumbnail}
        />
      )}

      <img {...props} src={image?.url} alt='Fallback' />
    </picture>
  )
}
